<template>
    <div>
        <Loading :value="loading" ></Loading>
        <v-dialog v-model="dialogDetail" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
            <v-card tile>
                <v-toolbar card dark color="primary">
                    <v-toolbar-title>Fiche de Validation des demandes d'approvisionnements</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="closeDialog()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-layout row>
                        <v-flex xs12>
                            <v-card color="" class="mb-5" flat >
                                <v-layout wrap>
                                    <v-flex xs12 >
                                        <v-alert  :value="true" outline color="purple" icon="info">
                                            Informations sur les demandes d'approvisionnements
                                        </v-alert>
                                        <v-card flat>
                                            <v-layout wrap>
                                                <v-card-text>
                                                    <v-flex xs12>
                                                        <v-flex xs12 class="text-xs-left"> <!--HAUT-->
                                                            <v-layout row>
                                                                <v-flex xs6 class="mr-4"> <!--COLONNE 1-->
                                                                    <v-layout row>
                                                                        <v-flex xs6>Trésorerie</v-flex>
                                                                        <v-flex xs6 class="text-xs-right title">
                                                                            {{approDetail.caisseType}}
                                                                        </v-flex>
                                                                    </v-layout>
                                                                    <v-divider class="mb-3"></v-divider>

                                                                    <v-layout row>
                                                                        <v-flex xs6>Date de la demande</v-flex>
                                                                        <v-flex xs6 class="text-xs-right title">
                                                                            {{approDetail.dateDmd}}
                                                                        </v-flex>
                                                                    </v-layout>
                                                                    <v-divider class="mb-3"></v-divider>

                                                                    <v-layout row>
                                                                        <v-flex xs6>Demande éffectuée par </v-flex>
                                                                        <v-flex xs6 class="text-xs-right title">
                                                                            {{approDetail.initiateur}}
                                                                        </v-flex>
                                                                    </v-layout>
                                                                    <v-divider class="mb-3"></v-divider>

                                                                    <v-layout row>
                                                                        <v-flex xs6>Motif de la demande </v-flex>
                                                                        <v-flex xs6 class="text-xs-right title">
                                                                            {{approDetail.motif}}
                                                                        </v-flex>
                                                                    </v-layout>
                                                                    <v-divider class="mb-3"></v-divider>

                                                                    <v-layout row>
                                                                        <v-flex xs6>MONTANT (TTC): </v-flex>
                                                                        <v-flex color="orange" xs6 class="text-xs-right title">
                                                                          <v-chip style="font-size:20px" label outline color="green">
                                                                            {{approDetail.montant}} FCFA
                                                                          </v-chip>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                    <v-divider class="mb-3"></v-divider>
                                                                </v-flex>

                                                                <v-flex xs6 class="text-xs-left"> <!--BAS-->
                                                                    <v-layout row>
                                                                        <v-flex xs6>Libellé trésorerie</v-flex>
                                                                        <v-flex xs6 class="text-xs-right title">
                                                                            {{approDetail.caisseLibelle}}
                                                                        </v-flex>
                                                                    </v-layout>
                                                                    <v-divider class="mb-3"></v-divider>

                                                                    <v-layout row>
                                                                        <v-flex xs6>Solde actuel</v-flex>
                                                                        <v-flex xs6 class="text-xs-right title">
                                                                            {{approDetail.caisseSolde}} FCFA
                                                                        </v-flex>
                                                                    </v-layout>
                                                                    <v-divider class="mb-3"></v-divider>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                    </v-flex>
                                                </v-card-text>
                                            </v-layout>
                                        </v-card>
                                    </v-flex>

                                </v-layout>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
            <v-tooltip top>
                <v-btn  class="mb-5" style="margin-right: 100px"
                   absolute
                   slot="activator" dark fab large bottom right color="red"
                   @click="dialogConfirmRefus = true">
                   <v-icon>close</v-icon>
                </v-btn>
                <span>Refuser la demande</span>
            </v-tooltip>

            <v-tooltip top>
                <v-btn class="mb-5 ml-5"
                   absolute slot="activator" dark
                   fab large bottom right color="green"
                   @click="dialogConfirm = true">
                   <v-icon>done</v-icon>
                </v-btn>
                <span>Valider la demande</span>
            </v-tooltip>
        </v-dialog>

         <v-layout row justify-center>
            <v-dialog v-model="dialogConfirmRefus" persistent max-width="650">
                <v-card>
                    <v-card-title class="headline">Validation de le demande d'approvisionnement</v-card-title>
                    <v-card-text>
                        <v-layout wrap>
                            <v-flex xs12 class="mb-2">
                                <el-alert
                                    title="Voulez vous Refuser cette demande ?"
                                    :closable="false"
                                    show-icon
                                    type="error">
                                </el-alert>
                            </v-flex>
                            <v-flex xs12>
                                <p class="grey--text font-weight-thin body-1">TRESORERIE: {{approDetail.caisseType}}</p>
                                <p class="grey--text font-weight-thin body-1">LIBELLE: {{approDetail.caisseLibelle}}</p>
                                <p class="grey--text font-weight-thin body-1">GERE PAR: {{approDetail.initiateur}}</p>
                            </v-flex>
                            <v-flex xs12>
                                 <el-form :model="formRefus" :rules="rulesRefus" ref="formRefus" id="formRefus" label-width="120px" class="demo-ruleForm">
                                    <el-form-item label="Commentaire" prop="rapport">
                                      <el-input type="textarea" name="rapport" placeholder="Laisser ici votre commentaire"  :rows="5" v-model="formRefus.rapport"></el-input>
                                    </el-form-item>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="grey darken-1" dark @click.native="resetFormRefusAppro('formRefus')">Annuler</v-btn>
                                        <v-btn color="red darken-1" dark @click.native="submitRefusAppro('formRefus')">Refuser</v-btn>
                                    </v-card-actions>
                                  </el-form>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-dialog>
         </v-layout>

        <!-- CONFIRMATION VALIDATION -->
        <v-layout row justify-center>
            <v-dialog v-model="dialogConfirm" persistent max-width="650px">
                <v-card>
                    <v-card-title class="headline">Validation de l'approvisionnement</v-card-title>
                    <v-card-text>
                        <v-layout wrap>
                            <v-flex xs12>
                                <p> <b>Vous</b> êtes sur le point de valider la demande</p>
                                <v-flex xs12>
                                  <p class="grey--text font-weight-thin body-1">APPRO-{{approDetail.id}}</p>
                                </v-flex>
                                <el-alert v-if="formValidate.choix == 2"
                                    title="NB: Par chèque le gerant sera tenu de completer les pièces de la transaction"
                                    type="warning" :closable="false">
                                </el-alert>
                            </v-flex>

                            <!-- <v-flex xs12> -->
                                <el-form :model="formValidate" :inline="true" ref="formValidate" label-width="150px" class="demo-ruleForm demo-form-inline">

                                  <v-layout row>
                                    <v-flex xs6 class="mr-1" >
                                      <el-form-item prop="choix" label="Type de règlement" :rules="[
                                          { required: true, message: 'Le champs est obligatoire'},
                                        ]">
                                        <el-select @change="changeReglement()" v-model="formValidate.choix" placeholder="Votre choix">
                                          <el-option label="En Espèce" value="1"></el-option>
                                          <el-option label="Par Chèque" value="2"></el-option>
                                          <el-option label="Autre" value="3"></el-option>
                                        </el-select>
                                      </el-form-item>
                                    </v-flex>

                                    <v-flex xs6 class="mr-1" v-if="formValidate.choix == 2" >
                                      <el-form-item prop="banque"  label="La banque" :rules="[
                                          { required: true, message: 'Le champs est obligatoire'},]">
                                        <el-select v-model="formValidate.banque" placeholder="La banque">
                                          <el-option v-for="item in listBanque" :key="item.value" :label="item.text" :value="item.value">
                                          </el-option>
                                        </el-select>
                                      </el-form-item>
                                    </v-flex>

                                    <v-flex xs6 class="mr-1"  v-if="formValidate.choix == 1">
                                      <el-form-item prop="banque"  label="La Caisse" :rules="[
                                          { required: true, message: 'Le champs est obligatoire'},]">
                                        <el-select v-model="formValidate.banque" placeholder="La caisse">
                                          <el-option v-for="item in listCaisse" :key="item.value" :label="item.text" :value="item.value">
                                          </el-option>
                                        </el-select>
                                      </el-form-item>
                                    </v-flex>


                                     <v-flex xs12 class="mr-2"  v-if="formValidate.choix == 3">
                                      <el-form-item prop="commentaire" label="Commentaire">
                                        <el-input type="textarea" name="commentaire" placeholder="Commentaire" :rows="2" v-model="formValidate.commantaire" style="width:100%"></el-input>
                                      </el-form-item>
                                    </v-flex>

                                  </v-layout>

                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="grey darken-1" dark @click.native="resetFormValidate('formValidate')">Annuler</v-btn>
                                    <v-btn color="green darken-1" dark  @click.native="submitValidate('formValidate')">Confirmer</v-btn>
                                  </v-card-actions>
                                </el-form>
                            <!-- </v-flex> -->
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-layout>
    </div>
</template>


<script>
    import Loading from '@/components/Loading'
    export default {
    components:{ Loading },
        name: "ModalValidationAppro",
        props:["show","approDetail","totalFact","listBanque","listCaisse"],
        data()
        {
         return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,
            dialogDetail: false,
            tableProduit:[],
            // listBanque:[],
            totalTTC:0,
            formRapport:{},
            dialogVisible: false,
            dialogImageUrl: '',
            imageDmd1: "",
            imageDmd2: "",
            imageDmd3: "",
            imageConst1: "",
            imageConst2: "",
            imageConst3: "",
            imageDepan1: "",
            imageDepan2: "",
            imageDepan3: "",
            dialogConfirmRefus: false,
            dialogConfirm: false,
            formRefus: {
              rapport: ''
            },
            rulesRefus: {
              rapport: [
                { required: true, message: 'Svp preciser la raison', trigger: 'blur' }
              ]
            },
            formValidate: {
              choix: '',
              banque:'',
              commantaire: ''
            }


         }
        },

        computed:{
        },
         watch: {
            show : function(newValue, oldvalue){
               this.dialogDetail = newValue
               if(newValue == true){

               }
            }
        },

        methods: {
            successNotif(mess = ""){
                this.$notify({
                    title: 'ENREGISTREMENT REUSSI',
                    message: mess,
                    type: 'success',
                    position: 'top-center'
                })
            },
            closeDialog(){
                this.$emit('close')
                this.dialogDetail = false
            },
            loadDevisConstat (){
                this.loading = true
                let url = this.domaine + 'demande_maintenance/devis/constat/'+this.factureDetail.idDemande
                this.$http.get(url).then(response => {
                    this.tableProduit = response.body.tableProduit
                    this.formRapport.rapport = response.body.rapport
                    this.totalTTC = response.body.total
                    this.loading = false
                },errResp=>{
                     this.loading = false
                      this.$message.error("Une erreur est survenue lors du chargement de la table des produits")
                })
            },

            // loadListBanque (){
            //     this.loading = true
            //     let url = this.domaine + 'caisse/tresor/'+ this.approDetail.caisseId +'/banque'
            //     this.$http.get(url).then(response => {
            //         this.listBanque = response.body.listBanque
            //         this.loading = false
            //     },errResp=>{
            //          this.loading = false
            //           this.$message.error("Une erreur est survenue lors du chargement de la liste banque")
            //     })
            // },

            handleSuccess(response, file, fileList){
                this.fileList.push(file)
            },
            handlePictureCardPreview(file, fileList) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            imprimerDetail(){
                let url = this.domaine+"demande_maintenance/imprimerPDF/demande/"+this.user.id+"/"+this.factureDetail.idDemande
                window.open(url)
            },
            SubmitValideDevis(){
                this.loading = true
                let url = this.domaine + 'fournisseur/valider/facture'

                let data = new FormData()
                data.append("id",  this.factureDetail.idFact)
                data.append("idUser",  this.user.id)
                data.append("remarque", " ")
                data.append("decision",  1)
                this.$http.post(url,data).then(response => {
                    this.loading = false
                    this.successNotif(response.body.message)
                    this.dialogConfirm = false
                    this.closeDialog();
                },errResp=>{
                     this.loading = false
                     this.$message.error("Une erreur est survenue lors de la facture")
                })
            },
            submitRefusAppro(formName) {
                this.$refs[formName].validate((valid) => {
                    if(valid) {

                        this.loading = true
                        let url = this.domaine + 'caisse/'+ this.approDetail.id +'/refus'
                        var form = document.getElementById('formRefus')
                        let data = new FormData(form)
                        // data.append("id", this.approDetail.caisseId)
                        data.append("commentaire",  this.formRefus.rapport)
                        this.$http.post(url,data).then(response => {
                            this.loading = false
                            this.successNotif(response.body.message)
                            this.dialogConfirmRefus = false
                            this.closeDialog();
                        }, errResp=>{
                             this.loading = false
                             this.$message.error("Une erreur est survenue lors de la facture")
                        })

                    } else {
                        return false;
                    }
                });
            },
            resetFormRefusAppro(formName) {
                this.$refs[formName].resetFields();
                this.dialogConfirmRefus = false
            },
            submitValidate(formName) {
                this.$refs[formName].validate((valid) => {
                  if (valid) {

                    this.loading = true
                    let url = this.domaine + 'caisse/'+ this.approDetail.id +'/accept'
                    let data = new FormData()
                    data.append("mode",  this.formValidate.choix)
                    data.append("banque",  this.formValidate.banque)
                    data.append("commantaire",  this.formValidate.commantaire)
                    data.append("idUser",  this.user.id)
                    this.$http.post(url,data).then(response => {
                        this.loading = false
                        this.successNotif(response.body.message)
                        this.dialogConfirm = false
                        this.formValidate.choix =""
                        this.formValidate.banque =""
                        this.formValidate.commantaire =""
                        this.closeDialog();
                    }, errResp=>{
                         this.loading = false
                         this.$message.error("Une erreur est survenue lors de la facture")
                    })

                  } else {
                    return false;
                  }
                });
            },
            changeReglement () {
                if (this.formValidate.choix == 2) {
                    this.formValidate.banque = ''
                } else{
                  this.formValidate.banque = ''
                }
            },
            resetFormValidate(formName) {
                this.$refs[formName].resetFields();
                this.dialogConfirm = false
            }

        },
        mounted(){
        }

    }
    </script>



// WEBPACK FOOTER //
// src/components/validationDG/ModalValidationAppro.vue